import React, { ComponentType } from 'react'
import { css } from 'src/ui/style/css'

export type ImageProps = {
    src: string
    className?: string
    height?: number
    width?: number | string
    style?: React.CSSProperties
    fitToParent?: boolean
    onClick?: () => void
    onLoad?: React.ReactEventHandler<HTMLImageElement>
    alt: string
    fetchpriority?: 'high' | 'low' | 'auto'
}

const fitToParentStyle = css`
    width: 100%;
    height: 100%;
    object-fit: cover;
`

export const Image: ComponentType<ImageProps> = ({
    src,
    height,
    width,
    style,
    className,
    fitToParent,
    alt,
    onClick,
    onLoad,
    fetchpriority,
    ...props
}) => (
    <img
        {...props}
        height={height}
        width={width}
        style={style}
        alt={alt}
        src={src}
        onClick={onClick}
        onLoad={onLoad}
        {...(fetchpriority ? { fetchpriority } : {})}
        css={css`
            ${fitToParent && fitToParentStyle};
            ${onClick && 'cursor: pointer'}
        `}
        className={className}
    />
)
